import * as React from 'react';
import { createUseStyles } from 'react-jss';
import { Theme } from 'helpers/theme';
import Icon from 'sharedComponents/core/Icon';
import moment from 'moment';

const useStyles = createUseStyles((theme: Theme) => ({
  statusRoot: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  textContent: {
    display: 'flex',
    flexDirection: 'column',
    marginLeft: 12
  },
  statusText: {
    fontSize: theme.fontSizes.tiny,
    color: theme.colors.secondaryBlack,
    textTransform: 'capitalize'
  },
  expiresText: {
    fontSize: theme.fontSizes.small,
    color: theme.colors.textBlue
  }
}));

type Status = 'complete' | 'incomplete' | 'failed' | '%future added value';
type Props = {
  status: Status;
  expires?: string;
};

function Status({ status, expires }: Props) {
  const classes = useStyles();
  return (
    <div className={classes.statusRoot}>
      {status === 'complete' && (
        <Icon size={17} name="CourseStatus_Completed" />
      )}
      {status !== 'complete' && (
        <Icon size={17} name="CourseStatus_Incomplete" />
      )}
      <div className={classes.textContent}>
        <span className={classes.statusText}>{status}</span>
        {expires && (
          <span className={classes.expiresText}>
            [Expires {moment(expires).format('DD/MM/YYYY')}]
          </span>
        )}
      </div>
    </div>
  );
}

export default Status;
